export interface LinearIssue {
  id: string;
  identifier: string;
  title: string;
  state: {
    id: string;
    name: string;
    type: string;
    color: string;
  };
  team: {
    id: string;
    name: string;
    key: string;
  };
  url: string;
}

class LinearService {
  private apiKey = "";

  configure(apiKey: string) {
    this.apiKey = apiKey;
  }

  isConfigured(): boolean {
    return this.apiKey !== "";
  }

  private async graphql<T>(query: string): Promise<T> {
    const response = await fetch("/api/linear/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.apiKey,
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      throw new Error(`Linear API error: ${response.status}`);
    }

    const data = await response.json();
    if (data.errors?.length) {
      throw new Error(data.errors[0].message || "GraphQL error");
    }

    return data.data as T;
  }

  async validateConnection(): Promise<{ name: string; email: string }> {
    const data = await this.graphql<{
      viewer: { name: string; email: string };
    }>(`
      query {
        viewer {
          name
          email
        }
      }
    `);
    return data.viewer;
  }

  async getToReleaseIssues(): Promise<LinearIssue[]> {
    const data = await this.graphql<{ issues: { nodes: LinearIssue[] } }>(`
      query {
        issues(
          filter: { state: { type: { in: ["completed"] } } }
          first: 100
          orderBy: updatedAt
        ) {
          nodes {
            id
            identifier
            title
            state {
              id
              name
              type
              color
            }
            team {
              id
              name
              key
            }
            url
          }
        }
      }
    `);
    return data.issues.nodes;
  }
}

export const linearService = new LinearService();
